import blogPosts from './blogPosts.json';
import helpArticles from './helpArticles.json';

export { blogPosts, helpArticles };

export const getPost = (slug) => blogPosts.find((p) => p.slug === slug);

export const relatedPosts = (slug, n = 3) =>
  blogPosts.filter((p) => p.slug !== slug).slice(0, n);

export const getArticle = (slug) => helpArticles.find((a) => a.slug === slug);

export const HELP_CATEGORIES = [
  'Getting started',
  'Products & catalog',
  'Selling channels',
  'Payments & billing',
  'Shipping & orders',
  'Account & domains',
];

export const articlesByCategory = () => {
  const map = {};
  HELP_CATEGORIES.forEach((c) => { map[c] = []; });
  helpArticles.forEach((a) => {
    (map[a.category] = map[a.category] || []).push(a);
  });
  return map;
};

export const relatedArticles = (slug, category, n = 6) =>
  helpArticles.filter((a) => a.category === category && a.slug !== slug).slice(0, n);
